import {
    DEVICE_ANDROID,
    DEVICE_IOS,
} from './consts'
import { isWebView } from './admin/actions/index'

export const EVENT_REGISTRATION = 'registration'
export const EVENT_ATTENDANCE = 'attendance'
export const EVENT_MESSENGER = 'messenger'
export const EVENT_NAVIGATION = 'navigation'
export const EVENT_OTHER = 'other'
export const EVENT_PHOTO = 'photo'
export const EVENT_TYPE_DEFAULT = 0
export const EVENT_TYPE_REDIRECT = 1

export const TYPE_EVENT_DETAIL = {
    type: 3,
    hint: 'EVENT_DETAIL',
}

export const TYPE_GROUP_DETAIL = {
    type: 5,
    hint: 'GROUP_DETAIL',
}

export const TYPE_MESSENGER_THREAD = {
    type: 10,
    hint: 'MESSENGER_THREAD',
}

/**
 * Get default data
 *
 * @type {Object}
 */
export const defaultData = {
    close: false,
    data: null,
    type: EVENT_TYPE_DEFAULT,
    action: null,
}

/**
 * Get user navigator device or returns false if is not defined
 *
 * @type {string|boolean}
 */
export const navigatorDevice = ((navigator.userAgent.match(/(device-)(ios|android)/)) || [])[2] || false

/**
 * Send data to webview if webview exists
 *
 * @param {string} event
 * @param {string|Object|null} data
 * @return {boolean|Promise}
 */
export const sendWebViewEvent = (event, data = null) => {
    if (!navigatorDevice) {
        return false
    }

    if (data === null) {
        data = { ...defaultData }
    } else {
        data = {
            ...defaultData,
            ...data,
        }
    }

    if (navigatorDevice === DEVICE_IOS && window && window.webkit) {
        window.webkit.messageHandlers[event].postMessage(data)
        return new Promise(resolve => resolve(data))
    }

    if (navigatorDevice === DEVICE_ANDROID && window && window[event]) {
        window[event].postMessage(JSON.stringify(data))
        return new Promise(resolve => resolve(data))
    }

    return false
}

/**
 * Try send webview event, or redirect out
 *
 * @param {string} link
 * @param {string|null} target
 * @param {boolean} redirectAfterFail - redirect after fail sending webview event?
 * @return {boolean}
 */
export const redirectWithEvents = (link, target = null, redirectAfterFail = true) => {
    const eventData = {
        type: EVENT_TYPE_REDIRECT,
        action: link,
    }

    if (sendWebViewEvent(EVENT_OTHER, eventData) === false) {
        if (redirectAfterFail) {
            if (target === '_blank') {
                window.open(link, '_blank')
            } else {
                window.location.href = link
            }
        }

        return true
    }

    return false
}

/**
 * Replace all links inside container with event click
 *
 * @param {Object} container
 */
export const setEventsForLinks = container => {
    if (isWebView() && container) {
        const links = container.getElementsByTagName('a')

        if (links.length > 0) {
            Object.values(links).forEach(link => {
                link.onclick = function(e){
                    e.preventDefault()
                    redirectWithEvents(this.href, '_blank')
                }
            })
        }
    }
}

/**
 * Check if webview is Android
 * @type {boolean}
 */
export const isAndroidWebView = navigatorDevice === DEVICE_ANDROID

/**
 * Check if webview is iOS
 * @type {boolean}
 */
export const isiOSWebView = navigatorDevice === DEVICE_IOS
